// ERROR TYPES
export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";

// OTP REQUEST TYPES
export const OTP_REQUEST = "OTP_REQUEST";
export const OTP_SUCCESS = "OTP_SUCCESS";
export const OTP_FAILURE = "OTP_FAILURE";
export const OTP_RESET = "OTP_RESET";

// LOGIN REQUEST TYPES
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

// LOGIN REQUEST TYPES
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

// NBFC LOGIN REQUEST TYPES
export const NBFC_LOGIN_REQUEST = "NBFC_LOGIN_REQUEST";
export const NBFC_LOGIN_SUCCESS = "NBFC_LOGIN_SUCCESS";
export const NBFC_LOGIN_FAILURE = "NBFC_LOGIN_FAILURE";

// NBFC LOGIN REQUEST TYPES
export const NBFC_LOGOUT_REQUEST = "NBFC_LOGOUT_REQUEST";
export const NBFC_LOGOUT_SUCCESS = "NBFC_LOGOUT_SUCCESS";
export const NBFC_LOGOUT_FAILURE = "NBFC_LOGOUT_FAILURE";


//FETCH_DYNAMICTABLE
export const FETCH_DYNAMICTABLE_REQUEST = "FETCH_DYNAMICTABLE_REQUEST";
export const FETCH_DYNAMICTABLE_SUCCESS = "FETCH_DYNAMICTABLE_SUCCESS";
export const FETCH_DYNAMICTABLE_FAILURE = "FETCH_DYNAMICTABLE_FAILURE";

//AIRTABLE FETCH AUCTION DATA LIST
export const FETCH_AUCTION_LIST_REQUEST = "FETCH_AUCTION_LIST_REQUEST";
export const FETCH_AUCTION_LIST_SUCCESS = "FETCH_AUCTION_LIST_SUCCESS";
export const FETCH_AUCTION_LIST_FAILURE = "FETCH_AUCTION_LIST_FAILURE";
export const FETCH_AUCTION_LIST_RESET = "FETCH_AUCTION_LIST_RESET";

//AIRTABLE SUBMIT BID
export const BID_SUBMIT_REQUEST = "BID_SUBMIT_REQUEST";
export const BID_SUBMIT_SUCCESS = "BID_SUBMIT_SUCCESS";
export const BID_SUBMIT_FAILURE = "BID_SUBMIT_FAILURE";
export const BID_SUBMIT_RESET = "BID_SUBMIT_RESET";

//AIRTABLE FETCH AUCTION LIST
export const FETCH_AUCTION_TABLE_LIST_REQUEST = "FETCH_AUCTION_TABLE_LIST_REQUEST";
export const FETCH_AUCTION_TABLE_LIST_SUCCESS = "FETCH_AUCTION_TABLE_LIST_SUCCESS";
export const FETCH_AUCTION_TABLE_LIST_FAILURE = "FETCH_AUCTION_TABLE_LIST_FAILURE";
export const FETCH_AUCTION_TABLE_LIST_RESET = "FETCH_AUCTION_TABLE_LIST_RESET";


//AIRTABLE FETCH MFS LIST
export const FETCH_MFSINV_LIST_REQUEST = "FETCH_MFSINV_LIST_REQUEST";
export const FETCH_MFSINV_LIST_SUCCESS = "FETCH_MFSINV_LIST_SUCCESS";
export const FETCH_MFSINV_LIST_FAILURE = "FETCH_MFSINV_LIST_FAILURE";
export const FETCH_MFSINV_LIST_RESET = "FETCH_MFSINV_LIST_RESET";

//AIRTABLE SUBMIT MFS
export const MFS_SUBMIT_REQUEST = "MFS_SUBMIT_REQUEST";
export const MFS_SUBMIT_SUCCESS = "MFS_SUBMIT_SUCCESS";
export const MFS_SUBMIT_FAILURE = "MFS_SUBMIT_FAILURE";
export const MFS_SUBMIT_RESET = "MFS_SUBMIT_RESET";



//FETCH AUCTION LIST
export const FETCH_ALL_AUCTION_LIST_REQUEST = "FETCH_ALL_AUCTION_LIST_REQUEST";
export const FETCH_ALL_AUCTION_LIST_SUCCESS = "FETCH_ALL_AUCTION_LIST_SUCCESS";
export const FETCH_ALL_AUCTION_LIST_FAILURE = "FETCH_ALL_AUCTION_LIST_FAILURE";
export const FETCH_ALL_AUCTION_LIST_RESET = "FETCH_ALL_AUCTION_LIST_RESET";

//FETCH AUCTION INV LIST
export const FETCH_AUCTION_INV_REQUEST = "FETCH_AUCTION_INV_REQUEST";
export const FETCH_AUCTION_INV_SUCCESS = "FETCH_AUCTION_INV_SUCCESS";
export const FETCH_AUCTION_INV_FAILURE = "FETCH_AUCTION_INV_FAILURE";
export const FETCH_AUCTION_INV_RESET = "FETCH_AUCTION_INV_RESET";

//SUBMIT BID
export const SUBMIT_BID_REQUEST = "SUBMIT_BID_REQUEST";
export const SUBMIT_BID_SUCCESS = "SUBMIT_BID_SUCCESS";
export const SUBMIT_BID_FAILURE = "SUBMIT_BID_FAILURE";
export const SUBMIT_BID_RESET = "SUBMIT_BID_RESET";

//FEATURE SETTING
export const FETCH_FEATURE_SETTING_REQUEST = "FETCH_FEATURE_SETTING_REQUEST";
export const FETCH_FEATURE_SETTING_SUCCESS = "FETCH_FEATURE_SETTING_SUCCESS";
export const FETCH_FEATURE_SETTING_FAILURE = "FETCH_FEATURE_SETTING_FAILURE";

//CREATE_AUCTION
export const CREATE_AUCTION_REQUEST = "CREATE_AUCTION_REQUEST";
export const CREATE_AUCTION_SUCCESS = "CREATE_AUCTION_SUCCESS";
export const CREATE_AUCTION_FAILURE = "CREATE_AUCTION_FAILURE";
export const CREATE_AUCTION_RESET = "CREATE_AUCTION_RESET";

//FETCH_UPLOADED_AUCTION
export const FETCH_UPLOADED_AUCTION_REQUEST = "FETCH_UPLOADED_AUCTION_REQUEST";
export const FETCH_UPLOADED_AUCTION_SUCCESS = "FETCH_UPLOADED_AUCTION_SUCCESS";
export const FETCH_UPLOADED_AUCTION_FAILURE = "FETCH_UPLOADED_AUCTION_FAILURE";

//FETCH_UPLOADED_AUCTION_INVENTORY
export const FETCH_UPLOADED_AUCTION_INVENTORY_REQUEST = "FETCH_UPLOADED_AUCTION_INVENTORY_REQUEST";
export const FETCH_UPLOADED_AUCTION_INVENTORY_SUCCESS = "FETCH_UPLOADED_AUCTION_INVENTORY_SUCCESS";
export const FETCH_UPLOADED_AUCTION_INVENTORY_FAILURE = "FETCH_UPLOADED_AUCTION_INVENTORY_FAILURE";

//FETCH_BID_STATUS
export const FETCH_BID_STATUS_REQUEST = "FETCH_BID_STATUS_REQUEST";
export const FETCH_BID_STATUS_SUCCESS = "FETCH_BID_STATUS_SUCCESS";
export const FETCH_BID_STATUS_FAILURE = "FETCH_BID_STATUS_FAILURE";

//SUBMIT_UPDATE_BID_STATUS
export const SUBMIT_UPDATE_BID_STATUS_REQUEST = "SUBMIT_UPDATE_BID_STATUS_REQUEST";
export const SUBMIT_UPDATE_BID_STATUS_SUCCESS = "SUBMIT_UPDATE_BID_STATUS_SUCCESS";
export const SUBMIT_UPDATE_BID_STATUS_FAILURE = "SUBMIT_UPDATE_BID_STATUS_FAILURE";
export const SUBMIT_UPDATE_BID_STATUS_RESET = "SUBMIT_UPDATE_BID_STATUS_RESET";


